<template>
  <FormSelect
    :options="countryList"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:option="{option}">
      <img
        :src="getCountryFlag(option.alpha2Code)"
        width="16"
        height="16"
        :alt="option.name"
        style="margin-right: .5rem"
      />
      {{ option.name }}
    </template>
  </FormSelect>
</template>

<script>
import {FormSelect} from '../FormSelect'

export default {
  components: {
    FormSelect,
  },

  props: {
    countryList: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Select country',
    },
  },

  inheritAttrs: false,

  methods: {
    getCountryFlag (code) {
      try {
        return require(`svg-country-flags/svg/${code.toLowerCase()}.svg`)
      } catch (error) {
        console.error(error)
        return null
      }
    },
  },
}
</script>
